import { AllSignalsCommon } from './shared/all-signals-common-view';

export const AllSignals = () => {
  return <AllSignalsCommon isListView={false} />;
};
